import { RouterModel } from "../models/router.model";
import { lazy } from "react";
import {
  BuildingDetails,
  ClientDetails,
  BuildingsForm,
  ClientForm,
  CreateRole,
  RoleDetails,
  UpdateRole,
  UserDetails,
  UsersForm,
  PlantDetails,
  PlantsForm,
  DisturbancesList,
  DisturbanceDetails,
  ResolvedDisturbanceList,
  CreateDisturbance,
  UpdateDisturbance,
  ComponentsList,
  ComponentsForm,
  ComponentDetails,
  ProductForm,
  ProductDetails,
  PlantProductForm,
  PlantProductsList,
  PlantProductDetails,
  TasksList,
  TasksForm,
  TaskDetails,
  ResolvedTasksList,
  SubTasksForm,
  SubTaskDetails,
  TrafficLightsForm,
  TrafficLightDetails,
  ResolvedSubTasksList,
  ResolvedMicroSubTasksList,
  OnsiteSubTasksList,
  ComponentOutlet,
  LabSubTasksList,
  TaskSettingsList,
  TaskSettingsDetails,
  UsersCahngeForm,
  ContactsForm,
  ContactDetails,
  YearlyPdfPage,
  VisitTaskForm,
  VisitTaskList,
  VdiClientForm,
  DrinkingWaterTasksList,
  TaskSearchList,
  AllDrinkingWaterBuildingsList,
  ActionsList,
  ActionDetails,
  PlantVisitTaskDetails,
  ClientsUsersList,
} from "./lazy-imports";

import ClientsList from "../components/clients/clients-list";
import ProductsList from "../components/products/products-list";
import RolesList from "../components/roles/roles-list";
import UsersList from "../components/users/users-list";
import AssignedTasksList from "../components/tasks/assigned-tasks-list";
import ComponentAudits from "../components/components/component-audits/component-audits";
import VisitTaskDetails from "../components/visit-tasks/visit-task-details";

/**
 * Routes for the Activity page and its child pages.
 */
export const ActivityRoute: RouterModel[] = [
  { path: "", title: "Assigned Sub Tasks", Component: AssignedTasksList },
  {
    path: "sub-tasks/:subTaskId",
    title: "Sub Task Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Task Details",
        Component: SubTaskDetails,
      },
    ],
  },
];

/**
 * Routes for the Drinking Water Tasks page.
 */
/**
 * Routes for the Task Search page.
 */
export const TaskSearchRoute: RouterModel[] = [
  { path: "", title: "Task Search", Component: TaskSearchList },
  {
    path: "sub-tasks/:subTaskId",
    title: "Sub Task Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Task Details",
        Component: SubTaskDetails,
      },
    ],
  },
];

export const DrinkingWaterTasksRoute: RouterModel[] = [
  { path: "", title: "Drinking Water Tasks", Component: DrinkingWaterTasksList },
  {
    path: "sub-tasks/:subTaskId",
    title: "Sub Task Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Task Details",
        Component: SubTaskDetails,
      },
    ],
  },
];

/**
 * Routes for the All Drinking Water Buildings page.
 */
export const AllDrinkingWaterBuildingsRoute: RouterModel[] = [
  { path: "", title: "All Drinking Water Buildings", Component: AllDrinkingWaterBuildingsList },
];

/**
 * Routes related to Sub Tasks.
 */
export const SubTasksRoute: RouterModel[] = [
  {
    path: "create",
    title: "Create Sub Task",
    Component: SubTasksForm,
  },
  {
    path: ":subTaskId",
    title: "Sub Task Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Task Details",
        Component: SubTaskDetails,
      },
    ],
  },
];

/**
 * Routes related to Tasks and their child Sub Tasks.
 */
export const TasksRoute: RouterModel[] = [
  {
    path: "",
    title: "Tasks",
    Component: TasksList,
  },
  {
    path: "create",
    title: "Create Task",
    Component: TasksForm,
  },
  {
    path: ":taskId",
    title: "Task Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Task Details",
        Component: TaskDetails,
      },
      {
        path: "sub-tasks",
        title: "Sub Tasks",
        Component: ComponentOutlet,
        children: SubTasksRoute,
      },
    ],
  },
];

/**
 * Routes for Task Settings management.
 */
export const TaskSettingsRoute: RouterModel[] = [
  {
    path: "",
    title: "Task Settigs",
    Component: TaskSettingsList,
  },
  {
    path: ":taskId",
    title: "Task settings details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Task Settigs",
        Component: TaskSettingsDetails,
      },
    ],
  },
];

/**
 * Routes related to Components management.
 */
export const ComponentsRoute: RouterModel[] = [
  {
    path: "",
    title: "Components",
    Component: ComponentsList,
  },
  {
    path: "create",
    title: "Create Component",
    Component: ComponentsForm,
  },
  {
    path: ":componentId",
    title: "Component Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Component Details",
        Component: ComponentDetails,
      },
      {
        path: "update",
        title: "Update Component",
        Component: ComponentsForm,
      },
      {
        path: "audits",
        title: "Component Audits",
        Component: ComponentAudits,
      },
    ],
  },
];

/**
 * Routes for Disturbance records.
 */
export const DisturbancesRoute: RouterModel[] = [
  {
    path: "",
    title: "Disturbances",
    Component: DisturbancesList,
  },
  {
    path: "create",
    title: "Create Disturbance",
    Component: CreateDisturbance,
  },
  {
    path: "update/:disturbanceId",
    title: "Update Disturbance",
    Component: UpdateDisturbance,
  },
  {
    path: ":disturbanceId",
    title: "Disturbance Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Disturbance Details",
        Component: DisturbanceDetails,
      },
    ],
  },
];

export const ActionsRoute: RouterModel[] = [
  {
    path: "",
    title: "Actions",
    Component: ActionsList,
  },
  {
    path: ":actionId",
    title: "Action Details",
    Component: ActionDetails,
  },
];

/**
 * Routes for Products management.
 */
export const ProductsRoute: RouterModel[] = [
  {
    path: "",
    title: "Products",
    Component: ProductsList,
  },
  {
    path: "create",
    title: "Create Product",
    Component: ProductForm,
  },
  {
    path: "update/:productId",
    title: "Update Product",
    Component: ProductForm,
  },
  {
    path: ":productId",
    title: "Product Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Product Details",
        Component: ProductDetails,
      },
    ],
  },
];


/**
 * Routes for Plant Products management.
 */
export const PlantProductsRoute: RouterModel[] = [
  {
    path: "",
    title: "Plant Products",
    Component: PlantProductsList,
  },
  {
    path: "create",
    title: "Plant Create Product",
    Component: PlantProductForm,
  },
  {
    path: "update/:productId",
    title: "Plant Update Product",
    Component: PlantProductForm,
  },
  {
    path: ":productId",
    title: "Plant Product Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Plant Product Details",
        Component: PlantProductDetails,
      },
    ],
  },
];

/**
 * Routes for managing Traffic Light records.
 */
export const TrafficLightRoute: RouterModel[] = [
  { path: "", title: "Traffic Light", Component: TrafficLightDetails },
  {
    path: "create",
    title: "Create Traffic Light",
    Component: TrafficLightsForm,
  },
  {
    path: "update",
    title: "Update Traffic Light",
    Component: TrafficLightsForm,
  },
];

/**
 * Routes for viewing Sub Task history and reports.
 */
export const HistoryPageRoute: RouterModel[] = [
  {
    path: "resolved-subtasks",
    title: "History - Resolved Subtasks",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "History - Resolved Subtasks",
        Component: ResolvedSubTasksList,
      },
      {
        path: ":subTaskId",
        title: "Sub Task Details",
        Component: ComponentOutlet,
        children: [
          {
            path: "",
            title: "Task Details",
            Component: SubTaskDetails,
          },
        ],
      },
    ],
  },
  {
    path: "plant-visit-tasks",
    title: "History - Plant Visit Tasks",
    Component: ComponentOutlet,
    children: [
      {
        path: ":plantVisitTaskId",
        title: "Plant Visit Task Details",
        Component: PlantVisitTaskDetails, 
      },
    ],
  },
  {
    path: "resolved-disturbances",
    title: "History - Resolved Disturbances",
    Component: ResolvedDisturbanceList,
  },
  {
    path: "onsite-subtasks-diagram",
    title: "History -On Site Subtasks Diagram",
    Component: OnsiteSubTasksList,
  },
  {
    path: "micro-subtasks-diagram",
    title: "History -Micro Subtasks Diagram",
    Component: ResolvedMicroSubTasksList,
  },
  {
    path: "lab-subtasks-diagram",
    title: "History -Lab Subtasks Diagram",
    Component: LabSubTasksList,
  },
  {
    path: "yearly-pdf-report",
    title: "History - Yearly Pdf Report ",
    Component: YearlyPdfPage,
  },
];

/**
 * Routes for managing Plants and their related records.
 */
export const PlantsRoute: RouterModel[] = [
  {
    path: ":plantId",
    title: "Plant Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Plant Details",
        Component: PlantDetails,
      },
      {
        path: "operating-time",
        title: "Laufzeiten der Anlage",
        Component: ComponentOutlet,
        children: [
          {
            path: "",
            title: "Laufzeiten der Anlage",
            Component: lazy(() => import("../components/plants/plant-operating-time/operating-time")),
          },
        ],
      },
      {
        path: "disturbances",
        title: "Disturbances",
        Component: ComponentOutlet,
        children: DisturbancesRoute,
      },
      {
        path: "actions",
        title: "Actions",
        Component: ComponentOutlet,
        children: ActionsRoute,
      },
      {
        path: "components",
        title: "Components",
        Component: ComponentOutlet,
        children: ComponentsRoute,
      },
      {
        path: "traffic-light",
        title: "Traffic Light",
        Component: ComponentOutlet,
        children: TrafficLightRoute,
      },
      {
        path: "history",
        title: "History",
        Component: ComponentOutlet,
        children: HistoryPageRoute,
      },
      {
        path: "plant-products",
        title: "Plant Products",
        Component: ComponentOutlet,
        children: PlantProductsRoute,
      },
    ],
  },
  {
    path: "create",
    title: "Create Plant",
    Component: PlantsForm,
  },
  {
    path: "update/:plantId",
    title: "Update Plant",
    Component: PlantsForm,
  },
];

/**
 * Routes for managing Buildings inside Clients.
 */
export const BuildingRoute: RouterModel[] = [
  {
    path: "create",
    title: "Create Building",
    Component: BuildingsForm,
  },
  {
    path: "update/:buildingId",
    title: "Update Building",
    Component: BuildingsForm,
  },
  {
    path: ":buildingId",
    title: "Building Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Building Details",
        Component: BuildingDetails,
      },
      {
        path: "tasks",
        title: "Tasks",
        Component: ComponentOutlet,
        children: TasksRoute,
      },
      {
        path: "task-settings",
        title: "Tasks",
        Component: ComponentOutlet,
        children: TaskSettingsRoute,
      },
      {
        path: "history",
        title: "History",
        Component: ComponentOutlet,
        children: [
          {
            path: "",
            title: "History",
            Component: ResolvedTasksList,
          },
          {
            path: "tasks/:taskId",
            title: "Task Details",
            Component: ComponentOutlet,
            children: [
              {
                path: "",
                title: "Task Details",
                Component: TaskDetails,
              },
              {
                path: "sub-tasks",
                title: "Sub Tasks",
                Component: ComponentOutlet,
                children: SubTasksRoute,
              },
            ],
          },
        ],
      },
      {
        path: "plants",
        title: "Plants",
        Component: ComponentOutlet,
        children: PlantsRoute,
      },
    ],
  },
];

/**
 * Routes for managing Contacts inside Clients.
 */
export const ContactRoute: RouterModel[] = [
  {
    path: "create",
    title: "Create Contact",
    Component: ContactsForm,
  },
  {
    path: "update/:contactId",
    title: "Update Contact",
    Component: ContactsForm,
  },
  {
    path: ":contactId",
    title: "Contact Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Contact Details",
        Component: ContactDetails,
      },
    ],
  },
];

/**
 * Routes for managing Clients.
 */
export const ClientsRoute: RouterModel[] = [
  {
    path: "",
    title: "Clients",
    Component: ClientsList,
  },
  {
    path: "create",
    title: "Create Client",
    Component: ClientForm,
  }, 
  {
    path: "vdi-create",
    title: "Create VDI Client",
    Component: VdiClientForm,
  },
  {
    path: "update/:clientId",
    title: "Update Client",
    Component: ClientForm,
  },
  {
    path: ":clientId",
    title: "Client Details",
    Component: ComponentOutlet,
    children: [
      {
        path: "",
        title: "Client Details",
        Component: ClientDetails,
      },
      {
        path: "visits",
        title: "Visits",
        Component: ComponentOutlet,
        children: [
          {
            path: "",
            title: "Visits History",
            Component: VisitTaskList,
          },
          {
            path: "create",
            title: "Create Visit",
            Component: VisitTaskForm,
          },
          {
            path: ":visitId",
            title: "View Visit",
            Component: VisitTaskDetails,
          }
        ]
      },
      {
        path: "buildings",
        title: "Buildings",
        Component: ComponentOutlet,
        children: BuildingRoute,
      },
      {
        path: "contacts",
        title: "Contacts",
        Component: ComponentOutlet,
        children: ContactRoute,
      },
    ],
  },
];

/**
 * Routes for managing Roles.
 */
export const RolesRoute: RouterModel[] = [
  {
    path: "",
    title: "Roles",
    Component: RolesList,
  },
  {
    path: ":id",
    title: "Role Details",
    Component: RoleDetails,
  },
  {
    path: "create",
    title: "Create Role",
    Component: CreateRole,
  },
  {
    path: "update/:id",
    title: "Update Role",
    Component: UpdateRole,
  },
];

/**
 * Routes for managing Users.
 */
export const UsersRoute: RouterModel[] = [
  {
    path: "",
    title: "Staff Users",
    Component: UsersList,
  },
  {
    path: "clients",
    title: "Clients Users",
    Component: ClientsUsersList,
  },
  {
    path: "create",
    title: "Create User",
    Component: UsersForm,
  },
  {
    path: "update/:id",
    title: "Update User",
    Component: UsersForm,
  },
  {
    path: "change/:id",
    title: "Update User",
    Component: UsersCahngeForm,
  },
  {
    path: ":id",
    title: "User Details",
    Component: UserDetails,
  },
];
